import React from 'react'
import './ExpCard.modules.css'
function Card({ title, duration, description }) {
  return (
    <div className='card'>
      <div style={{ display: 'flex', justifyContent: "space-between", marginBottom:"20px" }}>
        <h5><b>{title}</b></h5>
        <div><b>{duration}</b></div>
      </div>
      <div>{description}</div>
    </div>
  )
}

export default Card